/* tslint:disable */
/* eslint-disable */
/**
 * Radianse User API - .Net 6
 * <b>Build:</b>Radianse.App.Users_main_2023.10.27.2
 *
 * The version of the OpenAPI document: UserApi_V1
 * Contact: support@radianse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 *
 * @export
 * @interface IADPrincipalIdentity
 */
export interface IADPrincipalIdentity {
  /**
   * @type {string}
   * @memberof IADPrincipalIdentity
   */
  tfp?: string;
  /**
   * @type {string}
   * @memberof IADPrincipalIdentity
   */
  objectIdentifier?: string;
  /**
   * @type {string}
   * @memberof IADPrincipalIdentity
   */
  authenticationType?: string;
  /**
   * @type {string}
   * @memberof IADPrincipalIdentity
   */
  identityProvider?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IActiveDirectoryUserType = {
  User: "User",
  Member: "Member",
} as const;

export type IActiveDirectoryUserType =
  typeof IActiveDirectoryUserType[keyof typeof IActiveDirectoryUserType];

/**
 *
 * @export
 * @interface IApiClientRoles
 */
export interface IApiClientRoles {
  /**
   * Client Id.
   * @type {string}
   * @memberof IApiClientRoles
   */
  clientId: string;
  /**
   * Client Secret.
   * @type {string}
   * @memberof IApiClientRoles
   */
  secret: string;
  /**
   * Name
   * @type {string}
   * @memberof IApiClientRoles
   */
  name: string;
  /**
   * Token Lifetime.
   * @type {number}
   * @memberof IApiClientRoles
   */
  tokenLifetimeInMinutes?: number;
  /**
   * Authorized
   * @type {boolean}
   * @memberof IApiClientRoles
   */
  authorized?: boolean;
  /**
   * Customer ID
   * @type {string}
   * @memberof IApiClientRoles
   */
  customerId: string;
  /**
   * Customer roles
   * @type {Array<string>}
   * @memberof IApiClientRoles
   */
  customerRoles?: Array<string> | null;
  /**
   * Group ID
   * @type {string}
   * @memberof IApiClientRoles
   */
  groupId: string;
  /**
   * Group Roles
   * @type {Array<string>}
   * @memberof IApiClientRoles
   */
  groupRoles?: Array<string> | null;
  /**
   * Tenant ID
   * @type {string}
   * @memberof IApiClientRoles
   */
  tenantId: string;
  /**
   * Tenant Roles
   * @type {Array<string>}
   * @memberof IApiClientRoles
   */
  tenantRoles?: Array<string> | null;
}
/**
 *
 * @export
 * @interface IApiClientRolesListIRadianseResult
 */
export interface IApiClientRolesListIRadianseResult {
  /**
   * @type {number}
   * @memberof IApiClientRolesListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IApiClientRoles>}
   * @memberof IApiClientRolesListIRadianseResult
   */
  data?: Array<IApiClientRoles> | null;
  /**
   * @type {string}
   * @memberof IApiClientRolesListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IApiClientRolesListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IApiClientRolesListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IApiClientRolesListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IApiClientRolesListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IApiClientRolesListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IApiClientRolesListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IApiClientRolesListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IApiClientRolesListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IApiClientRolesResult
 */
export interface IApiClientRolesResult {
  /**
   * @type {string}
   * @memberof IApiClientRolesResult
   */
  clientId: string;
  /**
   * @type {string}
   * @memberof IApiClientRolesResult
   */
  secret?: string | null;
}
/**
 *
 * @export
 * @interface IApiClientRolesResultIRadianseResultSuccess
 */
export interface IApiClientRolesResultIRadianseResultSuccess {
  /**
   * @type {number}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  count?: number | null;
  /**
   * @type {IApiClientRolesResult}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  data: IApiClientRolesResult;
  /**
   * @type {string}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IApiClientRolesResultIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * Create a B2C active directory user
 * @export
 * @interface IB2CCreateUserDto
 */
export interface IB2CCreateUserDto {
  /**
   * @type {IClientTreeType}
   * @memberof IB2CCreateUserDto
   */
  scopeType: IClientTreeType;
  /**
   *
   * @type {string}
   * @memberof IB2CCreateUserDto
   */
  email: string;
  /**
   * Roles from Radianse.Api.RolesManager api
   * @type {Array<string>}
   * @memberof IB2CCreateUserDto
   */
  roles: Array<string>;
  /**
   * A display name for the roles applied. Defaults to \"Roles\".
   * @type {string}
   * @memberof IB2CCreateUserDto
   */
  rolesName?: string | null;
}
/**
 *
 * @export
 * @interface IClientModelAuthResp
 */
export interface IClientModelAuthResp {
  /**
   * @type {string}
   * @memberof IClientModelAuthResp
   */
  clientId?: string;
  /**
   * @type {string}
   * @memberof IClientModelAuthResp
   */
  secret?: string;
  /**
   * @type {string}
   * @memberof IClientModelAuthResp
   */
  name?: string;
  /**
   * @type {number}
   * @memberof IClientModelAuthResp
   */
  tokenLifetimeInMinutes?: number;
}
/**
 *
 * @export
 * @interface IClientModelAuthRespIRadianseResultSuccess
 */
export interface IClientModelAuthRespIRadianseResultSuccess {
  /**
   * @type {number}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  count?: number | null;
  /**
   * @type {IClientModelAuthResp}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  data: IClientModelAuthResp;
  /**
   * @type {string}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IClientModelAuthRespIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IClientModelsAuthResp
 */
export interface IClientModelsAuthResp {
  /**
   * @type {string}
   * @memberof IClientModelsAuthResp
   */
  clientId?: string;
  /**
   * @type {string}
   * @memberof IClientModelsAuthResp
   */
  secret?: string;
  /**
   * @type {string}
   * @memberof IClientModelsAuthResp
   */
  name?: string;
  /**
   * @type {number}
   * @memberof IClientModelsAuthResp
   */
  tokenLifetimeInMinutes?: number;
  /**
   * @type {boolean}
   * @memberof IClientModelsAuthResp
   */
  authorized?: boolean;
}
/**
 *
 * @export
 * @interface IClientModelsAuthRespListIRadianseResultSuccess
 */
export interface IClientModelsAuthRespListIRadianseResultSuccess {
  /**
   * @type {number}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   * @type {Array<IClientModelsAuthResp>}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  data: Array<IClientModelsAuthResp>;
  /**
   * @type {string}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IClientModelsAuthRespListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IClientTree
 */
export interface IClientTree {
  /**
   * @type {string}
   * @memberof IClientTree
   */
  id?: string | null;
  /**
   * @type {string}
   * @memberof IClientTree
   */
  parentId?: string | null;
  /**
   * @type {string}
   * @memberof IClientTree
   */
  name: string;
  /**
   * @type {IClientTreeType}
   * @memberof IClientTree
   */
  type?: IClientTreeType;
}
/**
 *
 * @export
 * @interface IClientTreeIListIRadianseResult
 */
export interface IClientTreeIListIRadianseResult {
  /**
   * @type {number}
   * @memberof IClientTreeIListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IClientTree>}
   * @memberof IClientTreeIListIRadianseResult
   */
  data?: Array<IClientTree> | null;
  /**
   * @type {string}
   * @memberof IClientTreeIListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IClientTreeIListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IClientTreeIListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IClientTreeIListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IClientTreeIListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IClientTreeIListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IClientTreeIListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IClientTreeIListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IClientTreeIListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IClientTreeType = {
  Customer: "Customer",
  Tenant: "Tenant",
  Group: "Group",
} as const;

export type IClientTreeType =
  typeof IClientTreeType[keyof typeof IClientTreeType];

/**
 *
 * @export
 * @interface ICreateCustomerRoleResult
 */
export interface ICreateCustomerRoleResult {
  /**
   * @type {string}
   * @memberof ICreateCustomerRoleResult
   */
  invitationCode: string;
  /**
   * @type {boolean}
   * @memberof ICreateCustomerRoleResult
   */
  isNewUser?: boolean;
  /**
   * @type {string}
   * @memberof ICreateCustomerRoleResult
   */
  userProfileId: string;
}
/**
 *
 * @export
 * @interface ICreateCustomerRoleResultIRadianseResultSuccess
 */
export interface ICreateCustomerRoleResultIRadianseResultSuccess {
  /**
   * @type {number}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  count?: number | null;
  /**
   * @type {ICreateCustomerRoleResult}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  data: ICreateCustomerRoleResult;
  /**
   * @type {string}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  title?: string;
  /**
   * @type {string}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof ICreateCustomerRoleResultIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * Response for GET /users/user/me
 * @export
 * @interface IGetMeResp
 */
export interface IGetMeResp {
  /**
   * Customer Id.
   * @type {string}
   * @memberof IGetMeResp
   */
  customerId: string;
  /**
   * Customer Name
   * @type {string}
   * @memberof IGetMeResp
   */
  customerName: string;
  /**
   * Customer Roles
   * @type {Array<string>}
   * @memberof IGetMeResp
   */
  customerRoles?: Array<string> | null;
  /**
   * Group Id.
   * @type {string}
   * @memberof IGetMeResp
   */
  groupId?: string | null;
  /**
   * Group Name
   * @type {string}
   * @memberof IGetMeResp
   */
  groupName?: string | null;
  /**
   * Group Roles
   * @type {Array<string>}
   * @memberof IGetMeResp
   */
  groupRoles?: Array<string> | null;
  /**
   * Email.
   * @type {string}
   * @memberof IGetMeResp
   */
  email: string;
  /**
   * First Name.
   * @type {string}
   * @memberof IGetMeResp
   */
  firstName?: string | null;
  /**
   * Last Name.
   * @type {string}
   * @memberof IGetMeResp
   */
  lastName?: string | null;
  /**
   * First Name.
   * @type {string}
   * @memberof IGetMeResp
   */
  name?: string | null;
  /**
   * Primary Role.
   * @type {string}
   * @memberof IGetMeResp
   */
  primaryRole?: string | null;
  /**
   * Tenant Id.
   * @type {string}
   * @memberof IGetMeResp
   */
  tenantId?: string | null;
  /**
   * Tenant Id.
   * @type {string}
   * @memberof IGetMeResp
   */
  tenantName?: string | null;
  /**
   * Tenant Roles
   * @type {Array<string>}
   * @memberof IGetMeResp
   */
  tenantRoles?: Array<string> | null;
  /**
   * User Profile Id.
   * @type {string}
   * @memberof IGetMeResp
   */
  userProfileId: string;
  /**
   * Identity Profile Id.
   * @type {string}
   * @memberof IGetMeResp
   */
  identityProfileId: string;
  /**
   * Application permissions per app scoped to customer
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IGetMeResp
   */
  customerPermissionsPerApp?: { [key: string]: Array<string> } | null;
  /**
   * Application permissions per app scoped to group
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IGetMeResp
   */
  groupPermissionsPerApp?: { [key: string]: Array<string> } | null;
  /**
   * Application permissions per app scoped to tenant
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IGetMeResp
   */
  tenantPermissionsPerApp?: { [key: string]: Array<string> } | null;
}
/**
 *
 * @export
 * @interface IGetMeRespIRadianseResult
 */
export interface IGetMeRespIRadianseResult {
  /**
   * @type {number}
   * @memberof IGetMeRespIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IGetMeResp}
   * @memberof IGetMeRespIRadianseResult
   */
  data?: IGetMeResp;
  /**
   * @type {string}
   * @memberof IGetMeRespIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IGetMeRespIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IGetMeRespIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IGetMeRespIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IGetMeRespIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IGetMeRespIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IGetMeRespIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IGetMeRespIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IGetMeRespIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIRadianseRequestContext
 */
export interface IIRadianseRequestContext {
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  clientAccessToken?: string;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  acceptLanguage?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  ipAddress?: string;
  /**
   * @type {boolean}
   * @memberof IIRadianseRequestContext
   */
  isUserRequest?: boolean;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToCustomerId?: string;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToGroupId?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToTenantId?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  userAccessToken?: string;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  detail?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  identityProfileId?: string;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  clientRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantRoles?: Array<string>;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerPermissions?: Array<string> | null;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupPermissions?: Array<string> | null;
  /**
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantPermissions?: Array<string> | null;
}
/**
 *
 * @export
 * @interface IIRadianseResult
 */
export interface IIRadianseResult {
  /**
   * @type {string}
   * @memberof IIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIdentityProfile
 */
export interface IIdentityProfile {
  /**
   * @type {string}
   * @memberof IIdentityProfile
   */
  category?: string;
  /**
   * @type {string}
   * @memberof IIdentityProfile
   */
  subCategory?: string;
  /**
   * @type {string}
   * @memberof IIdentityProfile
   */
  id: string;
  /**
   * @type {string}
   * @memberof IIdentityProfile
   */
  partitionKey?: string;
  /**
   * @type {{ [key: string]: IIdentityProfileInfo; }}
   * @memberof IIdentityProfile
   */
  rolesDic: { [key: string]: IIdentityProfileInfo };
  /**
   * @type {IIdentityProfileType}
   * @memberof IIdentityProfile
   */
  type?: IIdentityProfileType;
  /**
   * @type {boolean}
   * @memberof IIdentityProfile
   */
  deleted?: boolean;
}
/**
 *
 * @export
 * @interface IIdentityProfileIRadianseResultSuccess
 */
export interface IIdentityProfileIRadianseResultSuccess {
  /**
   * @type {number}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  count?: number | null;
  /**
   * @type {IIdentityProfile}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  data: IIdentityProfile;
  /**
   * @type {string}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IIdentityProfileIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IIdentityProfileInfo
 */
export interface IIdentityProfileInfo {
  /**
   * @type {Array<string>}
   * @memberof IIdentityProfileInfo
   */
  roles: Array<string>;
  /**
   * @type {string}
   * @memberof IIdentityProfileInfo
   */
  name: string;
}
/**
 *
 * @export
 * @interface IIdentityProfileInfoDto
 */
export interface IIdentityProfileInfoDto {
  /**
   * @type {Array<string>}
   * @memberof IIdentityProfileInfoDto
   */
  roles: Array<string>;
  /**
   * @type {string}
   * @memberof IIdentityProfileInfoDto
   */
  rolesName?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IIdentityProfileType = {
  ApiClient: "ApiClient",
  B2cUser: "B2cUser",
} as const;

export type IIdentityProfileType =
  typeof IIdentityProfileType[keyof typeof IIdentityProfileType];

/**
 *
 * @export
 * @interface IProblemDetails
 */
export interface IProblemDetails {
  [key: string]: any;

  /**
   * @type {string}
   * @memberof IProblemDetails
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IProblemDetails
   */
  title?: string | null;
  /**
   * @type {number}
   * @memberof IProblemDetails
   */
  status?: number | null;
  /**
   * @type {string}
   * @memberof IProblemDetails
   */
  detail?: string | null;
  /**
   * @type {string}
   * @memberof IProblemDetails
   */
  instance?: string | null;
}
/**
 *
 * @export
 * @interface IStringIRadianseResult
 */
export interface IStringIRadianseResult {
  /**
   * @type {number}
   * @memberof IStringIRadianseResult
   */
  count?: number | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  data?: string | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IStringIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IStringIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IStringIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IStringIRadianseResultSuccess
 */
export interface IStringIRadianseResultSuccess {
  /**
   * @type {number}
   * @memberof IStringIRadianseResultSuccess
   */
  count?: number | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  data: string;
  /**
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IStringIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IStringIRadianseResultSuccess
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IStringIRadianseResultSuccess
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IUserGlobalTenantProfile
 */
export interface IUserGlobalTenantProfile {
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  id?: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  category?: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  subCategory?: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   * @deprecated
   */
  b2cObjectIdentifier?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  createdBy: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  defaultCustomerId: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  defaultTenantId?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  defaultGroupId?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  email: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  firstName?: string | null;
  /**
   * @type {boolean}
   * @memberof IUserGlobalTenantProfile
   */
  deleted?: boolean;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  lastName?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  name: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  partitionKey?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  primaryRole?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  userProfileId: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   * @deprecated
   */
  userFlow?: string | null;
  /**
   * @type {IActiveDirectoryUserType}
   * @memberof IUserGlobalTenantProfile
   */
  userType?: IActiveDirectoryUserType;
  /**
   * @type {Array<IADPrincipalIdentity>}
   * @memberof IUserGlobalTenantProfile
   */
  identities?: Array<IADPrincipalIdentity> | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  customerId: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   * @deprecated
   */
  customerRole?: string | null;
  /**
   * @type {Array<string>}
   * @memberof IUserGlobalTenantProfile
   */
  customerRoles?: Array<string> | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  groupId?: string | null;
  /**
   * @type {Array<string>}
   * @memberof IUserGlobalTenantProfile
   */
  groupRoles?: Array<string> | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   */
  tenantId?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfile
   * @deprecated
   */
  tenantRole?: string | null;
  /**
   * @type {Array<string>}
   * @memberof IUserGlobalTenantProfile
   */
  tenantRoles?: Array<string> | null;
}
/**
 *
 * @export
 * @interface IUserGlobalTenantProfileICollectionIRadianseResult
 */
export interface IUserGlobalTenantProfileICollectionIRadianseResult {
  /**
   * @type {number}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IUserGlobalTenantProfile>}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  data?: Array<IUserGlobalTenantProfile> | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IUserGlobalTenantProfileICollectionIRadianseResultSuccess
 */
export interface IUserGlobalTenantProfileICollectionIRadianseResultSuccess {
  /**
   * @type {number}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  count?: number | null;
  /**
   * @type {Array<IUserGlobalTenantProfile>}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  data: Array<IUserGlobalTenantProfile>;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileICollectionIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IUserGlobalTenantProfileListIRadianseResult
 */
export interface IUserGlobalTenantProfileListIRadianseResult {
  /**
   * @type {number}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  count?: number | null;
  /**
   * @type {Array<IUserGlobalTenantProfile>}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  data?: Array<IUserGlobalTenantProfile> | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IUserGlobalTenantProfileListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IUserProfileAndRoles
 */
export interface IUserProfileAndRoles {
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   * @deprecated
   */
  b2cObjectIdentifier?: string | null;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  createdBy: string;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  defaultCustomerId: string;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  defaultGroupId?: string | null;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  defaultTenantId?: string | null;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  email: string;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  firstName?: string | null;
  /**
   * @type {boolean}
   * @memberof IUserProfileAndRoles
   */
  deleted?: boolean;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  lastName?: string | null;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  name: string;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  primaryRole?: string | null;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  userProfileId: string;
  /**
   * @type {Array<IADPrincipalIdentity>}
   * @memberof IUserProfileAndRoles
   */
  identities?: Array<IADPrincipalIdentity> | null;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  customerName: string;
  /**
   * @type {string}
   * @memberof IUserProfileAndRoles
   */
  tenantName?: string | null;
  /**
   * @type {Array<string>}
   * @memberof IUserProfileAndRoles
   */
  customerRoles?: Array<string> | null;
  /**
   * @type {Array<string>}
   * @memberof IUserProfileAndRoles
   */
  groupRoles?: Array<string> | null;
  /**
   * @type {Array<string>}
   * @memberof IUserProfileAndRoles
   */
  tenantRoles?: Array<string> | null;
}
/**
 *
 * @export
 * @interface IUserProfileAndRolesIRadianseResult
 */
export interface IUserProfileAndRolesIRadianseResult {
  /**
   * @type {number}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  count?: number | null;
  /**
   * @type {IUserProfileAndRoles}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  data?: IUserProfileAndRoles;
  /**
   * @type {string}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  detail: string;
  /**
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   * @type {string}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  instance?: string | null;
  /**
   * @type {number}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  status?: number;
  /**
   * @type {boolean}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  success?: boolean;
  /**
   * @type {string}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  title?: string;
  /**
   * @type {string}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  traceId?: string | null;
  /**
   * @type {string}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  type?: string | null;
  /**
   * @type {string}
   * @memberof IUserProfileAndRolesIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IUserProfilePatch
 */
export interface IUserProfilePatch {
  /**
   * @type {string}
   * @memberof IUserProfilePatch
   */
  email?: string | null;
  /**
   * @type {string}
   * @memberof IUserProfilePatch
   */
  firstName?: string | null;
  /**
   * @type {string}
   * @memberof IUserProfilePatch
   */
  lastName?: string | null;
  /**
   * @type {string}
   * @memberof IUserProfilePatch
   */
  name?: string | null;
}
/**
 * Create identity and roles for a B2cUser or ApiClient
 * @export
 * @interface IUsersApiClientRolesDto
 */
export interface IUsersApiClientRolesDto {
  /**
   * Name of the ApiClient. Used for display purposes.
   * @type {string}
   * @memberof IUsersApiClientRolesDto
   */
  name: string;
  /**
   * Lifetime of token in minutes. Default to 60.
   * @type {number}
   * @memberof IUsersApiClientRolesDto
   */
  tokenLifetimeInMinutes?: number | null;
  /**
   * Roles. These roles have permissions associated with them
   * @type {Array<string>}
   * @memberof IUsersApiClientRolesDto
   */
  roles: Array<string>;
  /**
   * Name for roles, may be used to display to user
   * @type {string}
   * @memberof IUsersApiClientRolesDto
   */
  rolesName?: string | null;
  /**
   * @type {IClientTreeType}
   * @memberof IUsersApiClientRolesDto
   */
  clientTreeType?: IClientTreeType;
}

/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary UI calls endpoint to login and get information about the logged in user
     * @param {string} [requestParameters.tenantId] TenantId must be sent when using token
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userMeGet: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/User/Me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * Fp
     * @summary UI calls endpoint to login and get information about the logged in user
     * @param {string} [tenantId] TenantId must be sent when using token
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userMeGet(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IGetMeRespIRadianseResult>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userMeGet(
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserApiFp(configuration);
  return {
    /**
     *
     * Factory
     * @summary UI calls endpoint to login and get information about the logged in user
     * @param {string} [tenantId] TenantId must be sent when using token
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userMeGet(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IGetMeRespIRadianseResult> {
      return localVarFp
        .userMeGet(tenantId, apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
  /**
   *
   * --TEST
   * @summary UI calls endpoint to login and get information about the logged in user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userMeGet(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UserApiFp(this.configuration)
      .userMeGet(tenantId, apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UserApiApi - axios parameter creator
 * @export
 */
export const UserApiApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * If user has a customer role, the customer, groups, and tenants that belong to the customer will be returned.  If user has a group role, this method will return the group and tenants that belong to the group.  If user has a tenant role, the tenant will be returned.
     * @summary Get all customers/group/tenants a user or apiClient has roles for
     * @param {boolean} [requestParameters.forceReread] Defaults to true which reads from database. Cached is update every 10 to 20 minutes. If true, reread client tree from storage. If false, read from cache.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiClientTreeListGet: async (
      forceReread?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/ClientTreeList`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (forceReread !== undefined) {
        localVarQueryParameter["forceReread"] = forceReread;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: tenantuser_delete  If user is not a member of any other tenants, the user will be removed from B2C active  directory. The cosmos entries will mark the user as deleted.
     * @summary Delete the user from the customer, group, or tenant
     * @param {IClientTreeType} requestParameters.clientTreeType
     * @param {string} requestParameters.userProfileId
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUserClientTreeTypeUserProfileIdDelete: async (
      clientTreeType: IClientTreeType,
      userProfileId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientTreeType' is not null or undefined
      assertParamExists(
        "userApiUserClientTreeTypeUserProfileIdDelete",
        "clientTreeType",
        clientTreeType
      );
      // verify required parameter 'userProfileId' is not null or undefined
      assertParamExists(
        "userApiUserClientTreeTypeUserProfileIdDelete",
        "userProfileId",
        userProfileId
      );
      const localVarPath = `/UserApi/User/{clientTreeType}/{userProfileId}`
        .replace(
          `{${"clientTreeType"}}`,
          encodeURIComponent(String(clientTreeType))
        )
        .replace(
          `{${"userProfileId"}}`,
          encodeURIComponent(String(userProfileId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: customeruser_read                Only user\'s at same role hierarchy and children will be returned. The hierarchy is radianse->customer->group->tenant.  For example if logged in user\'s had just tenant roles, no user\'s with group or customer roles would be returned.
     * @summary Return all user\'s that belong to the customer, group, or tenant
     * @param {IClientTreeType} [requestParameters.clientTreeType] If null, all users from tenant
     * @param {Array<IActiveDirectoryUserType>} [requestParameters.userTypes] If userTypes is not included as a query parameter, return all types of users. If included with empty value, an error will be returned.
     * @param {boolean} [requestParameters.deleted]
     * @param {string} [requestParameters.tenantId] If using bearer token, tenantId is required if clientTreeType &#x3D; \&quot;Tenant\&quot;.
     * @param {string} [requestParameters.groupId] If using bearer token, groupId is required if clientTreeType &#x3D; \&quot;Group\&quot;.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUserGet: async (
      clientTreeType?: IClientTreeType,
      userTypes?: Array<IActiveDirectoryUserType>,
      deleted?: boolean,
      tenantId?: string,
      groupId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/User`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientTreeType !== undefined) {
        localVarQueryParameter["clientTreeType"] = clientTreeType;
      }

      if (userTypes) {
        localVarQueryParameter["userTypes"] = userTypes;
      }

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: user_read
     * @summary Get user profile and roles from userProfileId.
     * @param {string} requestParameters.userProfileId
     * @param {string} [requestParameters.groupId] If using a bearer token, include groupId
     * @param {string} [requestParameters.tenantId] If using a bearer token, include tenantId
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUserUserProfileIdGet: async (
      userProfileId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userProfileId' is not null or undefined
      assertParamExists(
        "userApiUserUserProfileIdGet",
        "userProfileId",
        userProfileId
      );
      const localVarPath = `/UserApi/User/{userProfileId}`.replace(
        `{${"userProfileId"}}`,
        encodeURIComponent(String(userProfileId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: user_edit
     * @summary Update editable fields in a user\'s profile
     * @param {string} requestParameters.userProfileId
     * @param {string} [requestParameters.groupId] If using a bearer token, include groupId
     * @param {string} [requestParameters.tenantId] If using a bearer token, include tenantId
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IUserProfilePatch} [requestParameters.iUserProfilePatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUserUserProfileIdPatch: async (
      userProfileId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iUserProfilePatch?: IUserProfilePatch,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'userProfileId' is not null or undefined
      assertParamExists(
        "userApiUserUserProfileIdPatch",
        "userProfileId",
        userProfileId
      );
      const localVarPath = `/UserApi/User/{userProfileId}`.replace(
        `{${"userProfileId"}}`,
        encodeURIComponent(String(userProfileId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iUserProfilePatch,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserApiApi - functional programming interface
 * @export
 */
export const UserApiApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserApiApiAxiosParamCreator(configuration);
  return {
    /**
     * If user has a customer role, the customer, groups, and tenants that belong to the customer will be returned.  If user has a group role, this method will return the group and tenants that belong to the group.  If user has a tenant role, the tenant will be returned.
     * Fp
     * @summary Get all customers/group/tenants a user or apiClient has roles for
     * @param {boolean} [forceReread] Defaults to true which reads from database. Cached is update every 10 to 20 minutes. If true, reread client tree from storage. If false, read from cache.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiClientTreeListGet(
      forceReread?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IClientTreeIListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiClientTreeListGet(
          forceReread,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: tenantuser_delete  If user is not a member of any other tenants, the user will be removed from B2C active  directory. The cosmos entries will mark the user as deleted.
     * Fp
     * @summary Delete the user from the customer, group, or tenant
     * @param {IClientTreeType} clientTreeType
     * @param {string} userProfileId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUserClientTreeTypeUserProfileIdDelete(
      clientTreeType: IClientTreeType,
      userProfileId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IUserGlobalTenantProfileICollectionIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUserClientTreeTypeUserProfileIdDelete(
          clientTreeType,
          userProfileId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: customeruser_read                Only user\'s at same role hierarchy and children will be returned. The hierarchy is radianse->customer->group->tenant.  For example if logged in user\'s had just tenant roles, no user\'s with group or customer roles would be returned.
     * Fp
     * @summary Return all user\'s that belong to the customer, group, or tenant
     * @param {IClientTreeType} [clientTreeType] If null, all users from tenant
     * @param {Array<IActiveDirectoryUserType>} [userTypes] If userTypes is not included as a query parameter, return all types of users. If included with empty value, an error will be returned.
     * @param {boolean} [deleted]
     * @param {string} [tenantId] If using bearer token, tenantId is required if clientTreeType &#x3D; \&quot;Tenant\&quot;.
     * @param {string} [groupId] If using bearer token, groupId is required if clientTreeType &#x3D; \&quot;Group\&quot;.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUserGet(
      clientTreeType?: IClientTreeType,
      userTypes?: Array<IActiveDirectoryUserType>,
      deleted?: boolean,
      tenantId?: string,
      groupId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IUserGlobalTenantProfileListIRadianseResult>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userApiUserGet(
        clientTreeType,
        userTypes,
        deleted,
        tenantId,
        groupId,
        apiVersion,
        acceptLanguage,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: user_read
     * Fp
     * @summary Get user profile and roles from userProfileId.
     * @param {string} userProfileId
     * @param {string} [groupId] If using a bearer token, include groupId
     * @param {string} [tenantId] If using a bearer token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUserUserProfileIdGet(
      userProfileId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IUserProfileAndRolesIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUserUserProfileIdGet(
          userProfileId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: user_edit
     * Fp
     * @summary Update editable fields in a user\'s profile
     * @param {string} userProfileId
     * @param {string} [groupId] If using a bearer token, include groupId
     * @param {string} [tenantId] If using a bearer token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IUserProfilePatch} [iUserProfilePatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUserUserProfileIdPatch(
      userProfileId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iUserProfilePatch?: IUserProfilePatch,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IUserGlobalTenantProfileICollectionIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUserUserProfileIdPatch(
          userProfileId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iUserProfilePatch,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * UserApiApi - factory interface
 * @export
 */
export const UserApiApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserApiApiFp(configuration);
  return {
    /**
     * If user has a customer role, the customer, groups, and tenants that belong to the customer will be returned.  If user has a group role, this method will return the group and tenants that belong to the group.  If user has a tenant role, the tenant will be returned.
     * Factory
     * @summary Get all customers/group/tenants a user or apiClient has roles for
     * @param {boolean} [forceReread] Defaults to true which reads from database. Cached is update every 10 to 20 minutes. If true, reread client tree from storage. If false, read from cache.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiClientTreeListGet(
      forceReread?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IClientTreeIListIRadianseResult> {
      return localVarFp
        .userApiClientTreeListGet(
          forceReread,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: tenantuser_delete  If user is not a member of any other tenants, the user will be removed from B2C active  directory. The cosmos entries will mark the user as deleted.
     * Factory
     * @summary Delete the user from the customer, group, or tenant
     * @param {IClientTreeType} clientTreeType
     * @param {string} userProfileId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUserClientTreeTypeUserProfileIdDelete(
      clientTreeType: IClientTreeType,
      userProfileId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IUserGlobalTenantProfileICollectionIRadianseResultSuccess> {
      return localVarFp
        .userApiUserClientTreeTypeUserProfileIdDelete(
          clientTreeType,
          userProfileId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: customeruser_read                Only user\'s at same role hierarchy and children will be returned. The hierarchy is radianse->customer->group->tenant.  For example if logged in user\'s had just tenant roles, no user\'s with group or customer roles would be returned.
     * Factory
     * @summary Return all user\'s that belong to the customer, group, or tenant
     * @param {IClientTreeType} [clientTreeType] If null, all users from tenant
     * @param {Array<IActiveDirectoryUserType>} [userTypes] If userTypes is not included as a query parameter, return all types of users. If included with empty value, an error will be returned.
     * @param {boolean} [deleted]
     * @param {string} [tenantId] If using bearer token, tenantId is required if clientTreeType &#x3D; \&quot;Tenant\&quot;.
     * @param {string} [groupId] If using bearer token, groupId is required if clientTreeType &#x3D; \&quot;Group\&quot;.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUserGet(
      clientTreeType?: IClientTreeType,
      userTypes?: Array<IActiveDirectoryUserType>,
      deleted?: boolean,
      tenantId?: string,
      groupId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IUserGlobalTenantProfileListIRadianseResult> {
      return localVarFp
        .userApiUserGet(
          clientTreeType,
          userTypes,
          deleted,
          tenantId,
          groupId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: user_read
     * Factory
     * @summary Get user profile and roles from userProfileId.
     * @param {string} userProfileId
     * @param {string} [groupId] If using a bearer token, include groupId
     * @param {string} [tenantId] If using a bearer token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUserUserProfileIdGet(
      userProfileId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IUserProfileAndRolesIRadianseResult> {
      return localVarFp
        .userApiUserUserProfileIdGet(
          userProfileId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: user_edit
     * Factory
     * @summary Update editable fields in a user\'s profile
     * @param {string} userProfileId
     * @param {string} [groupId] If using a bearer token, include groupId
     * @param {string} [tenantId] If using a bearer token, include tenantId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IUserProfilePatch} [iUserProfilePatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUserUserProfileIdPatch(
      userProfileId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iUserProfilePatch?: IUserProfilePatch,
      options?: any
    ): AxiosPromise<IUserGlobalTenantProfileICollectionIRadianseResultSuccess> {
      return localVarFp
        .userApiUserUserProfileIdPatch(
          userProfileId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iUserProfilePatch,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserApiApi - object-oriented interface
 * @export
 * @class UserApiApi
 * @extends {BaseAPI}
 */
export class UserApiApi extends BaseAPI {
  /**
   * If user has a customer role, the customer, groups, and tenants that belong to the customer will be returned.  If user has a group role, this method will return the group and tenants that belong to the group.  If user has a tenant role, the tenant will be returned.
   * --TEST
   * @summary Get all customers/group/tenants a user or apiClient has roles for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiApi
   */
  public userApiClientTreeListGet(
    forceReread?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UserApiApiFp(this.configuration)
      .userApiClientTreeListGet(
        forceReread,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: tenantuser_delete  If user is not a member of any other tenants, the user will be removed from B2C active  directory. The cosmos entries will mark the user as deleted.
   * --TEST
   * @summary Delete the user from the customer, group, or tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiApi
   */
  public userApiUserClientTreeTypeUserProfileIdDelete(
    clientTreeType: IClientTreeType,
    userProfileId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UserApiApiFp(this.configuration)
      .userApiUserClientTreeTypeUserProfileIdDelete(
        clientTreeType,
        userProfileId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: customeruser_read                Only user\'s at same role hierarchy and children will be returned. The hierarchy is radianse->customer->group->tenant.  For example if logged in user\'s had just tenant roles, no user\'s with group or customer roles would be returned.
   * --TEST
   * @summary Return all user\'s that belong to the customer, group, or tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiApi
   */
  public userApiUserGet(
    clientTreeType?: IClientTreeType,
    userTypes?: Array<IActiveDirectoryUserType>,
    deleted?: boolean,
    tenantId?: string,
    groupId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UserApiApiFp(this.configuration)
      .userApiUserGet(
        clientTreeType,
        userTypes,
        deleted,
        tenantId,
        groupId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: user_read
   * --TEST
   * @summary Get user profile and roles from userProfileId.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiApi
   */
  public userApiUserUserProfileIdGet(
    userProfileId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UserApiApiFp(this.configuration)
      .userApiUserUserProfileIdGet(
        userProfileId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: user_edit
   * --TEST
   * @summary Update editable fields in a user\'s profile
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiApi
   */
  public userApiUserUserProfileIdPatch(
    userProfileId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iUserProfilePatch?: IUserProfilePatch,
    options?: AxiosRequestConfig
  ) {
    return UserApiApiFp(this.configuration)
      .userApiUserUserProfileIdPatch(
        userProfileId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iUserProfilePatch,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UserApiRequestContextApi - axios parameter creator
 * @export
 */
export const UserApiRequestContextApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet: async (
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserApiRequestContextApi - functional programming interface
 * @export
 */
export const UserApiRequestContextApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    UserApiRequestContextApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * Fp
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequestContextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequestContextGet(
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * UserApiRequestContextApi - factory interface
 * @export
 */
export const UserApiRequestContextApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserApiRequestContextApiFp(configuration);
  return {
    /**
     *
     * Factory
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiRequestContextGet(apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserApiRequestContextApi - object-oriented interface
 * @export
 * @class UserApiRequestContextApi
 * @extends {BaseAPI}
 */
export class UserApiRequestContextApi extends BaseAPI {
  /**
   *
   * --TEST
   * @summary
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApiRequestContextApi
   */
  public userApiRequestContextGet(
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UserApiRequestContextApiFp(this.configuration)
      .userApiRequestContextGet(apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UserInvitationApi - axios parameter creator
 * @export
 */
export const UserInvitationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * If Scope type is Customer, authorization requires customerinvitation_create.  If Scope type is Group, authorization requires groupinvitation_create.  If Scope type is Tenant, authorization requires tenantinvitation_create
     * @summary Add a user to a customer, group or tenant with roles or edit an existing user
     * @param {string} [requestParameters.tenantId] If using bearer token, tenantId is required.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IB2CCreateUserDto} [requestParameters.iB2CCreateUserDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiInvitationPost: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iB2CCreateUserDto?: IB2CCreateUserDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Invitation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iB2CCreateUserDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Authorization requires resendinvitation_read
     * @summary User lost the invitation email or maybe it expired. Resend the invitation code.
     * @param {string} requestParameters.email
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiInvitationResendInvitationEmailGet: async (
      email: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'email' is not null or undefined
      assertParamExists(
        "userApiInvitationResendInvitationEmailGet",
        "email",
        email
      );
      const localVarPath =
        `/UserApi/Invitation/ResendInvitation/{email}`.replace(
          `{${"email"}}`,
          encodeURIComponent(String(email))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserInvitationApi - functional programming interface
 * @export
 */
export const UserInvitationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UserInvitationApiAxiosParamCreator(configuration);
  return {
    /**
     * If Scope type is Customer, authorization requires customerinvitation_create.  If Scope type is Group, authorization requires groupinvitation_create.  If Scope type is Tenant, authorization requires tenantinvitation_create
     * Fp
     * @summary Add a user to a customer, group or tenant with roles or edit an existing user
     * @param {string} [tenantId] If using bearer token, tenantId is required.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IB2CCreateUserDto} [iB2CCreateUserDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiInvitationPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iB2CCreateUserDto?: IB2CCreateUserDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiInvitationPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iB2CCreateUserDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Authorization requires resendinvitation_read
     * Fp
     * @summary User lost the invitation email or maybe it expired. Resend the invitation code.
     * @param {string} email
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiInvitationResendInvitationEmailGet(
      email: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiInvitationResendInvitationEmailGet(
          email,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * UserInvitationApi - factory interface
 * @export
 */
export const UserInvitationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UserInvitationApiFp(configuration);
  return {
    /**
     * If Scope type is Customer, authorization requires customerinvitation_create.  If Scope type is Group, authorization requires groupinvitation_create.  If Scope type is Tenant, authorization requires tenantinvitation_create
     * Factory
     * @summary Add a user to a customer, group or tenant with roles or edit an existing user
     * @param {string} [tenantId] If using bearer token, tenantId is required.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IB2CCreateUserDto} [iB2CCreateUserDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiInvitationPost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iB2CCreateUserDto?: IB2CCreateUserDto,
      options?: any
    ): AxiosPromise<IStringIRadianseResultSuccess> {
      return localVarFp
        .userApiInvitationPost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iB2CCreateUserDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Authorization requires resendinvitation_read
     * Factory
     * @summary User lost the invitation email or maybe it expired. Resend the invitation code.
     * @param {string} email
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiInvitationResendInvitationEmailGet(
      email: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IStringIRadianseResultSuccess> {
      return localVarFp
        .userApiInvitationResendInvitationEmailGet(
          email,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserInvitationApi - object-oriented interface
 * @export
 * @class UserInvitationApi
 * @extends {BaseAPI}
 */
export class UserInvitationApi extends BaseAPI {
  /**
   * If Scope type is Customer, authorization requires customerinvitation_create.  If Scope type is Group, authorization requires groupinvitation_create.  If Scope type is Tenant, authorization requires tenantinvitation_create
   * --TEST
   * @summary Add a user to a customer, group or tenant with roles or edit an existing user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserInvitationApi
   */
  public userApiInvitationPost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iB2CCreateUserDto?: IB2CCreateUserDto,
    options?: AxiosRequestConfig
  ) {
    return UserInvitationApiFp(this.configuration)
      .userApiInvitationPost(
        tenantId,
        apiVersion,
        acceptLanguage,
        iB2CCreateUserDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Authorization requires resendinvitation_read
   * --TEST
   * @summary User lost the invitation email or maybe it expired. Resend the invitation code.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserInvitationApi
   */
  public userApiInvitationResendInvitationEmailGet(
    email: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UserInvitationApiFp(this.configuration)
      .userApiInvitationResendInvitationEmailGet(
        email,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UsersIdentityApi - axios parameter creator
 * @export
 */
export const UsersIdentityApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: apiclient_create
     * @summary Authorize the api client
     * @param {string} requestParameters.clientId The clientId of the api client
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientAuthorizeClientIdPut: async (
      clientId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists(
        "userApiUsersIdentityApiClientAuthorizeClientIdPut",
        "clientId",
        clientId
      );
      const localVarPath =
        `/UserApi/UsersIdentity/ApiClient/Authorize/{clientId}`.replace(
          `{${"clientId"}}`,
          encodeURIComponent(String(clientId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: apiclient_read
     * @summary Get api clients and authorized parameter
     * @param {boolean} [requestParameters.deleted]
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientAuthorizeGet: async (
      deleted?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/UsersIdentity/ApiClient/Authorize`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: apiclient_read                Only api clients\'s at same role hierarchy and children will be returned. The hierarchy is radianse->customer->group->tenant.  For example if logged in user\'s had just tenant roles, no api clients with group or customer roles would be returned.
     * @summary Return all api clients\'s that belong to the customer, group, or tenant
     * @param {IClientTreeType} requestParameters.clientTreeType If null, all users from tenant
     * @param {boolean} [requestParameters.deleted]
     * @param {string} [requestParameters.tenantId] If using bearer token, tenantId is required if clientTreeType &#x3D; \&quot;Tenant\&quot;.
     * @param {string} [requestParameters.groupId] If using bearer token, groupId is required if clientTreeType &#x3D; \&quot;Group\&quot;.
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientClientTreeTypeGet: async (
      clientTreeType: IClientTreeType,
      deleted?: boolean,
      tenantId?: string,
      groupId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientTreeType' is not null or undefined
      assertParamExists(
        "userApiUsersIdentityApiClientClientTreeTypeGet",
        "clientTreeType",
        clientTreeType
      );
      const localVarPath =
        `/UserApi/UsersIdentity/ApiClient/{clientTreeType}`.replace(
          `{${"clientTreeType"}}`,
          encodeURIComponent(String(clientTreeType))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: apiclient_create
     * @summary Deauthorize the api client
     * @param {string} requestParameters.apiClientId
     * @param {string} [requestParameters.clientId] The clientId of the api client
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientDeauthorizeApiClientIdPut: async (
      apiClientId: string,
      clientId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'apiClientId' is not null or undefined
      assertParamExists(
        "userApiUsersIdentityApiClientDeauthorizeApiClientIdPut",
        "apiClientId",
        apiClientId
      );
      const localVarPath =
        `/UserApi/UsersIdentity/ApiClient/Deauthorize/{apiClientId}`.replace(
          `{${"apiClientId"}}`,
          encodeURIComponent(String(apiClientId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (clientId !== undefined) {
        localVarQueryParameter["clientId"] = clientId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: apiclient_delete
     * @summary Delete the api client and roles
     * @param {string} requestParameters.apiClientId The clientId of the api client
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientRolesApiClientIdDelete: async (
      apiClientId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'apiClientId' is not null or undefined
      assertParamExists(
        "userApiUsersIdentityApiClientRolesApiClientIdDelete",
        "apiClientId",
        apiClientId
      );
      const localVarPath =
        `/UserApi/UsersIdentity/ApiClientRoles/{apiClientId}`.replace(
          `{${"apiClientId"}}`,
          encodeURIComponent(String(apiClientId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: apiclient_create                ApiClient is a API client which will be authenticated via a token.
     * @summary Create an api cient and add customer, group, or tenant roles
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IUsersApiClientRolesDto} [requestParameters.iUsersApiClientRolesDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientRolesPost: async (
      apiVersion?: string,
      acceptLanguage?: string,
      iUsersApiClientRolesDto?: IUsersApiClientRolesDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/UsersIdentity/ApiClientRoles`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iUsersApiClientRolesDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: roles_delete
     * @summary Delete roles
     * @param {IClientTreeType} requestParameters.clientTreeType Customer, Group, or Tenant
     * @param {string} requestParameters.identityProfileId For roles on ApiClient, this value is the clientId. For roles on a B2cUser, this value is the UserProfileId
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdDelete: async (
      clientTreeType: IClientTreeType,
      identityProfileId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientTreeType' is not null or undefined
      assertParamExists(
        "userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdDelete",
        "clientTreeType",
        clientTreeType
      );
      // verify required parameter 'identityProfileId' is not null or undefined
      assertParamExists(
        "userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdDelete",
        "identityProfileId",
        identityProfileId
      );
      const localVarPath =
        `/UserApi/UsersIdentity/Roles/{clientTreeType}/{identityProfileId}`
          .replace(
            `{${"clientTreeType"}}`,
            encodeURIComponent(String(clientTreeType))
          )
          .replace(
            `{${"identityProfileId"}}`,
            encodeURIComponent(String(identityProfileId))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: roles_edit
     * @summary Edit roles
     * @param {IClientTreeType} requestParameters.clientTreeType Customer, Group, or Tenant
     * @param {string} requestParameters.identityProfileId For roles on ApiClient, this value is the clientId. For roles on a B2cUser, this value is the UserProfileId
     * @param {string} [requestParameters.apiVersion] The requested API version
     * @param {string} [requestParameters.acceptLanguage]
     * @param {IIdentityProfileInfoDto} [requestParameters.iIdentityProfileInfoDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdPut: async (
      clientTreeType: IClientTreeType,
      identityProfileId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iIdentityProfileInfoDto?: IIdentityProfileInfoDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientTreeType' is not null or undefined
      assertParamExists(
        "userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdPut",
        "clientTreeType",
        clientTreeType
      );
      // verify required parameter 'identityProfileId' is not null or undefined
      assertParamExists(
        "userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdPut",
        "identityProfileId",
        identityProfileId
      );
      const localVarPath =
        `/UserApi/UsersIdentity/Roles/{clientTreeType}/{identityProfileId}`
          .replace(
            `{${"clientTreeType"}}`,
            encodeURIComponent(String(clientTreeType))
          )
          .replace(
            `{${"identityProfileId"}}`,
            encodeURIComponent(String(identityProfileId))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iIdentityProfileInfoDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersIdentityApi - functional programming interface
 * @export
 */
export const UsersIdentityApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UsersIdentityApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: apiclient_create
     * Fp
     * @summary Authorize the api client
     * @param {string} clientId The clientId of the api client
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUsersIdentityApiClientAuthorizeClientIdPut(
      clientId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IClientModelAuthRespIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUsersIdentityApiClientAuthorizeClientIdPut(
          clientId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: apiclient_read
     * Fp
     * @summary Get api clients and authorized parameter
     * @param {boolean} [deleted]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUsersIdentityApiClientAuthorizeGet(
      deleted?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IClientModelsAuthRespListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUsersIdentityApiClientAuthorizeGet(
          deleted,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: apiclient_read                Only api clients\'s at same role hierarchy and children will be returned. The hierarchy is radianse->customer->group->tenant.  For example if logged in user\'s had just tenant roles, no api clients with group or customer roles would be returned.
     * Fp
     * @summary Return all api clients\'s that belong to the customer, group, or tenant
     * @param {IClientTreeType} clientTreeType If null, all users from tenant
     * @param {boolean} [deleted]
     * @param {string} [tenantId] If using bearer token, tenantId is required if clientTreeType &#x3D; \&quot;Tenant\&quot;.
     * @param {string} [groupId] If using bearer token, groupId is required if clientTreeType &#x3D; \&quot;Group\&quot;.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUsersIdentityApiClientClientTreeTypeGet(
      clientTreeType: IClientTreeType,
      deleted?: boolean,
      tenantId?: string,
      groupId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IApiClientRolesListIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUsersIdentityApiClientClientTreeTypeGet(
          clientTreeType,
          deleted,
          tenantId,
          groupId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: apiclient_create
     * Fp
     * @summary Deauthorize the api client
     * @param {string} apiClientId
     * @param {string} [clientId] The clientId of the api client
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUsersIdentityApiClientDeauthorizeApiClientIdPut(
      apiClientId: string,
      clientId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IClientModelAuthRespIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUsersIdentityApiClientDeauthorizeApiClientIdPut(
          apiClientId,
          clientId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: apiclient_delete
     * Fp
     * @summary Delete the api client and roles
     * @param {string} apiClientId The clientId of the api client
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUsersIdentityApiClientRolesApiClientIdDelete(
      apiClientId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ICreateCustomerRoleResultIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUsersIdentityApiClientRolesApiClientIdDelete(
          apiClientId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: apiclient_create                ApiClient is a API client which will be authenticated via a token.
     * Fp
     * @summary Create an api cient and add customer, group, or tenant roles
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IUsersApiClientRolesDto} [iUsersApiClientRolesDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUsersIdentityApiClientRolesPost(
      apiVersion?: string,
      acceptLanguage?: string,
      iUsersApiClientRolesDto?: IUsersApiClientRolesDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ICreateCustomerRoleResultIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUsersIdentityApiClientRolesPost(
          apiVersion,
          acceptLanguage,
          iUsersApiClientRolesDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: roles_delete
     * Fp
     * @summary Delete roles
     * @param {IClientTreeType} clientTreeType Customer, Group, or Tenant
     * @param {string} identityProfileId For roles on ApiClient, this value is the clientId. For roles on a B2cUser, this value is the UserProfileId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdDelete(
      clientTreeType: IClientTreeType,
      identityProfileId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIdentityProfileIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdDelete(
          clientTreeType,
          identityProfileId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },

    /**
     * Permission: roles_edit
     * Fp
     * @summary Edit roles
     * @param {IClientTreeType} clientTreeType Customer, Group, or Tenant
     * @param {string} identityProfileId For roles on ApiClient, this value is the clientId. For roles on a B2cUser, this value is the UserProfileId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IIdentityProfileInfoDto} [iIdentityProfileInfoDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdPut(
      clientTreeType: IClientTreeType,
      identityProfileId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iIdentityProfileInfoDto?: IIdentityProfileInfoDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IApiClientRolesResultIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdPut(
          clientTreeType,
          identityProfileId,
          apiVersion,
          acceptLanguage,
          iIdentityProfileInfoDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * UsersIdentityApi - factory interface
 * @export
 */
export const UsersIdentityApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UsersIdentityApiFp(configuration);
  return {
    /**
     * Permission: apiclient_create
     * Factory
     * @summary Authorize the api client
     * @param {string} clientId The clientId of the api client
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientAuthorizeClientIdPut(
      clientId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IClientModelAuthRespIRadianseResultSuccess> {
      return localVarFp
        .userApiUsersIdentityApiClientAuthorizeClientIdPut(
          clientId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: apiclient_read
     * Factory
     * @summary Get api clients and authorized parameter
     * @param {boolean} [deleted]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientAuthorizeGet(
      deleted?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IClientModelsAuthRespListIRadianseResultSuccess> {
      return localVarFp
        .userApiUsersIdentityApiClientAuthorizeGet(
          deleted,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: apiclient_read                Only api clients\'s at same role hierarchy and children will be returned. The hierarchy is radianse->customer->group->tenant.  For example if logged in user\'s had just tenant roles, no api clients with group or customer roles would be returned.
     * Factory
     * @summary Return all api clients\'s that belong to the customer, group, or tenant
     * @param {IClientTreeType} clientTreeType If null, all users from tenant
     * @param {boolean} [deleted]
     * @param {string} [tenantId] If using bearer token, tenantId is required if clientTreeType &#x3D; \&quot;Tenant\&quot;.
     * @param {string} [groupId] If using bearer token, groupId is required if clientTreeType &#x3D; \&quot;Group\&quot;.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientClientTreeTypeGet(
      clientTreeType: IClientTreeType,
      deleted?: boolean,
      tenantId?: string,
      groupId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IApiClientRolesListIRadianseResult> {
      return localVarFp
        .userApiUsersIdentityApiClientClientTreeTypeGet(
          clientTreeType,
          deleted,
          tenantId,
          groupId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: apiclient_create
     * Factory
     * @summary Deauthorize the api client
     * @param {string} apiClientId
     * @param {string} [clientId] The clientId of the api client
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientDeauthorizeApiClientIdPut(
      apiClientId: string,
      clientId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IClientModelAuthRespIRadianseResultSuccess> {
      return localVarFp
        .userApiUsersIdentityApiClientDeauthorizeApiClientIdPut(
          apiClientId,
          clientId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: apiclient_delete
     * Factory
     * @summary Delete the api client and roles
     * @param {string} apiClientId The clientId of the api client
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientRolesApiClientIdDelete(
      apiClientId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<ICreateCustomerRoleResultIRadianseResultSuccess> {
      return localVarFp
        .userApiUsersIdentityApiClientRolesApiClientIdDelete(
          apiClientId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: apiclient_create                ApiClient is a API client which will be authenticated via a token.
     * Factory
     * @summary Create an api cient and add customer, group, or tenant roles
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IUsersApiClientRolesDto} [iUsersApiClientRolesDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityApiClientRolesPost(
      apiVersion?: string,
      acceptLanguage?: string,
      iUsersApiClientRolesDto?: IUsersApiClientRolesDto,
      options?: any
    ): AxiosPromise<ICreateCustomerRoleResultIRadianseResultSuccess> {
      return localVarFp
        .userApiUsersIdentityApiClientRolesPost(
          apiVersion,
          acceptLanguage,
          iUsersApiClientRolesDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: roles_delete
     * Factory
     * @summary Delete roles
     * @param {IClientTreeType} clientTreeType Customer, Group, or Tenant
     * @param {string} identityProfileId For roles on ApiClient, this value is the clientId. For roles on a B2cUser, this value is the UserProfileId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdDelete(
      clientTreeType: IClientTreeType,
      identityProfileId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIdentityProfileIRadianseResultSuccess> {
      return localVarFp
        .userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdDelete(
          clientTreeType,
          identityProfileId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: roles_edit
     * Factory
     * @summary Edit roles
     * @param {IClientTreeType} clientTreeType Customer, Group, or Tenant
     * @param {string} identityProfileId For roles on ApiClient, this value is the clientId. For roles on a B2cUser, this value is the UserProfileId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IIdentityProfileInfoDto} [iIdentityProfileInfoDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdPut(
      clientTreeType: IClientTreeType,
      identityProfileId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iIdentityProfileInfoDto?: IIdentityProfileInfoDto,
      options?: any
    ): AxiosPromise<IApiClientRolesResultIRadianseResultSuccess> {
      return localVarFp
        .userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdPut(
          clientTreeType,
          identityProfileId,
          apiVersion,
          acceptLanguage,
          iIdentityProfileInfoDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UsersIdentityApi - object-oriented interface
 * @export
 * @class UsersIdentityApi
 * @extends {BaseAPI}
 */
export class UsersIdentityApi extends BaseAPI {
  /**
   * Permission: apiclient_create
   * --TEST
   * @summary Authorize the api client
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersIdentityApi
   */
  public userApiUsersIdentityApiClientAuthorizeClientIdPut(
    clientId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UsersIdentityApiFp(this.configuration)
      .userApiUsersIdentityApiClientAuthorizeClientIdPut(
        clientId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: apiclient_read
   * --TEST
   * @summary Get api clients and authorized parameter
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersIdentityApi
   */
  public userApiUsersIdentityApiClientAuthorizeGet(
    deleted?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UsersIdentityApiFp(this.configuration)
      .userApiUsersIdentityApiClientAuthorizeGet(
        deleted,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: apiclient_read                Only api clients\'s at same role hierarchy and children will be returned. The hierarchy is radianse->customer->group->tenant.  For example if logged in user\'s had just tenant roles, no api clients with group or customer roles would be returned.
   * --TEST
   * @summary Return all api clients\'s that belong to the customer, group, or tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersIdentityApi
   */
  public userApiUsersIdentityApiClientClientTreeTypeGet(
    clientTreeType: IClientTreeType,
    deleted?: boolean,
    tenantId?: string,
    groupId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UsersIdentityApiFp(this.configuration)
      .userApiUsersIdentityApiClientClientTreeTypeGet(
        clientTreeType,
        deleted,
        tenantId,
        groupId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: apiclient_create
   * --TEST
   * @summary Deauthorize the api client
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersIdentityApi
   */
  public userApiUsersIdentityApiClientDeauthorizeApiClientIdPut(
    apiClientId: string,
    clientId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UsersIdentityApiFp(this.configuration)
      .userApiUsersIdentityApiClientDeauthorizeApiClientIdPut(
        apiClientId,
        clientId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: apiclient_delete
   * --TEST
   * @summary Delete the api client and roles
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersIdentityApi
   */
  public userApiUsersIdentityApiClientRolesApiClientIdDelete(
    apiClientId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UsersIdentityApiFp(this.configuration)
      .userApiUsersIdentityApiClientRolesApiClientIdDelete(
        apiClientId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: apiclient_create                ApiClient is a API client which will be authenticated via a token.
   * --TEST
   * @summary Create an api cient and add customer, group, or tenant roles
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersIdentityApi
   */
  public userApiUsersIdentityApiClientRolesPost(
    apiVersion?: string,
    acceptLanguage?: string,
    iUsersApiClientRolesDto?: IUsersApiClientRolesDto,
    options?: AxiosRequestConfig
  ) {
    return UsersIdentityApiFp(this.configuration)
      .userApiUsersIdentityApiClientRolesPost(
        apiVersion,
        acceptLanguage,
        iUsersApiClientRolesDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: roles_delete
   * --TEST
   * @summary Delete roles
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersIdentityApi
   */
  public userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdDelete(
    clientTreeType: IClientTreeType,
    identityProfileId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UsersIdentityApiFp(this.configuration)
      .userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdDelete(
        clientTreeType,
        identityProfileId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: roles_edit
   * --TEST
   * @summary Edit roles
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersIdentityApi
   */
  public userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdPut(
    clientTreeType: IClientTreeType,
    identityProfileId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iIdentityProfileInfoDto?: IIdentityProfileInfoDto,
    options?: AxiosRequestConfig
  ) {
    return UsersIdentityApiFp(this.configuration)
      .userApiUsersIdentityRolesClientTreeTypeIdentityProfileIdPut(
        clientTreeType,
        identityProfileId,
        apiVersion,
        acceptLanguage,
        iIdentityProfileInfoDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
